import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { Template } from "types/generated";
import { AccountContext } from "views/AccountWrapper";
import useCanCreateTemplateDeployment from "shared/Templates/access/useCanCreateTemplateDeployment";

import { TemplateContext } from "../../Template/Context";
import TemplateDeployments from "../../Template/Deployments";
import { showTemplateDetailsDrawer } from "../../Template/DetailsDrawer";
import {
  getTemplateMarketplaceDeployFormUrl,
  getTemplateMarketplaceDeployFormAbsoluteUrl,
  getTemplateMarketplaceTemplateUrl,
} from "../utils";

type PageLayoutProps = {
  template: Template;
};

const PageLayout = ({ template }: PageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  const canDeployTemplate = useCanCreateTemplateDeployment();

  useTitle(`Templates · ${template.name} · ${accountName}`);

  const templateUrl = getTemplateMarketplaceTemplateUrl(template.id);
  const deploymentFormUrl = getTemplateMarketplaceDeployFormUrl(
    template.id,
    template.latestVersion!.id
  );
  const deploymentFormAbsoluteUrl = getTemplateMarketplaceDeployFormAbsoluteUrl(
    template.id,
    template.latestVersion!.id
  );

  const handleOpenDetailsDrawer = () => {
    showTemplateDetailsDrawer({ item: template });
  };

  return (
    <TemplateContext.Provider value={{ template, templateUrl, isMarketplace: true }}>
      <ViewHeader>
        <ViewHeaderWrapper direction="row" justify="between" fullWidth>
          <ViewHeaderWrapper direction="row" align="center">
            <ViewHeaderTitle>{template.name}</ViewHeaderTitle>
          </ViewHeaderWrapper>

          <ViewHeaderWrapper direction="row" align="end" shrink="0">
            <Button variant="secondary" onPress={handleOpenDetailsDrawer}>
              Details
            </Button>
            <DropdownMenuEllipsis
              tooltip="Template actions"
              id="template-view--dropdown-actions"
              dotsSize="medium"
            >
              <CopyFieldDropdownMenuItem title="Copy ID" value={template.id} />
              <CopyFieldDropdownMenuItem title="Copy Link" value={deploymentFormAbsoluteUrl} />

              <DropdownMenuItem
                href={deploymentFormUrl}
                isDisabled={!canDeployTemplate.result}
                tooltip={canDeployTemplate.message}
              >
                Deploy
              </DropdownMenuItem>
            </DropdownMenuEllipsis>
          </ViewHeaderWrapper>
        </ViewHeaderWrapper>
      </ViewHeader>

      <TemplateDeployments id={template.id} excludeTestDeployments />
    </TemplateContext.Provider>
  );
};

export default PageLayout;
